export const GET_PURCHASES_SALES_DEATHS_METADATA = 'GET_PURCHASES_SALES_DEATHS_METADATA'
export const GET_PURCHASES_SALES_DEATHS_METADATA_SUCCESS = 'GET_PURCHASES_SALES_DEATHS_METADATA_SUCCESS'
export const GET_PURCHASES_SALES_DEATHS_METADATA_FAIL = 'GET_PURCHASES_SALES_DEATHS_METADATA_FAIL'
export const RESET_PURCHASES_SALES_DEATHS_METADATA = 'RESET_PURCHASES_SALES_DEATHS_METADATA'

export const GET_PURCHASES_SALES_DEATHS_FORM_DATA = 'GET_PURCHASES_SALES_DEATHS_FORM_DATA'
export const GET_PURCHASES_SALES_DEATHS_FORM_DATA_SUCCESS = 'GET_PURCHASES_SALES_DEATHS_FORM_DATA_SUCCESS'
export const GET_PURCHASES_SALES_DEATHS_FORM_DATA_FAIL = 'GET_PURCHASES_SALES_DEATHS_FORM_DATA_FAIL'

export const GET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA = 'GET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA'
export const GET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA_SUCCESS = 'GET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA_SUCCESS'
export const GET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA_FAIL = 'GET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA_FAIL'

export const SET_PURCHASES_SALES_DEATHS_FORM_DATA = 'SET_PURCHASES_SALES_DEATHS_FORM_DATA'
export const SET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA = 'SET_PURCHASES_SALES_DEATHS_OTHER_SALES_DATA'
export const RESET_PURCHASES_SALES_DEATHS_ALL_DATA = 'RESET_PURCHASES_SALES_DEATHS_ALL_DATA'

export const RESPONSE_STATE_SUCCESS = 'RESPONSE_STATE_SUCCESS'
export const RESPONSE_STATE_FAIL = 'RESPONSE_STATE_FAIL'